import PropTypes from 'prop-types';
/* eslint-disable */
const UploadGalleryListPropType = {
  html: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default UploadGalleryListPropType;
